export const TOGGLE_BOOKMARK_PROGRAM = `
  mutation toggleBookmarkProgram($programID: String!) {
    toggleBookmarkProgram(programID: $programID) {
      status {
        message
        statusCode
      }
      data {
        id
        userId
        programId
      }
    }
  }
`;

export const GET_PROGRAMS_BOOKMARKED = `
  query getProgramsBookmarked($page: Int!) {
    getProgramsBookmarked(page: $page) {
      status {
        message
        statusCode
      }
      pagination {
        currentPage
        totalPages
        totalRecords
      }
      data {
        id
        uid
        title
        titleEnglish
        summary
        summaryEnglish
        typoGraphyImagePath
        description
        descriptionEnglish
        productionYear
        landscapeImagePath
        portraitImagePath
        bannerImagePath
        originalLanguageId
        isSolitary
      }
    }
  }
`;
